import { create } from 'zustand'

interface NotificationStore {
    notificationPermissionStatus: NotificationPermission | null
    setNotificationPermissionStatus: (
        notificationPermissionStatus: NotificationPermission
    ) => void
    token: string | null
    setToken: (token: string) => void
}

const useNotificationStore = create<NotificationStore>((set) => ({
    notificationPermissionStatus: null,
    token: null,
    setNotificationPermissionStatus: (notificationStatus) => {
        set({
            notificationPermissionStatus: notificationStatus,
        })
    },
    setToken: (token) => {
        set({
            token,
        })
    },
}))

export default useNotificationStore
